export default "__VITE_ASSET__MehHRLoq__"